var SecurityDomain = (function () {
    function SecurityDomain() {
    }
    return SecurityDomain;
}());
export { SecurityDomain };
